// extracted by mini-css-extract-plugin
module.exports = {"adfox":"_0fce717cdb--adfox--2c1sd"};